import React, { useContext, useEffect } from "react";
import { useIntl } from "react-intl";
//
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  sendEmailVerification,
  onIdTokenChanged,
} from "firebase/auth";
//
import { StoreContext } from "../../../store/StoreProvider";
import Act from "../../../store/actions";
//
import fireAuth from "./utils";
//
import urls from "../../project/ApiUrls";

// eslint-disable-next-line
const AuthListener = ({ auth }) => {
  const [state, dispatch] = useContext(StoreContext);
  const { uid, email, displayName } = state.user;
  //
  const intl = useIntl();

  useEffect(() => {
    // observer for user signIn and signup successfully and signOut
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userInfo = fireAuth.getFormatUser(user);

        const token = await user.getIdToken();
        dispatch({
          type: Act.FIREBASE_LOGIN_USER,
          payload: {
            ...userInfo,
            userInfo, // userInfo 可以用來儲存在 realtimeDb
            token,
          },
        });
        // localStorage
        localStorage.setItem("isLogin", JSON.stringify(true));
        // set axios token
        urls.setAxiosAuth(token);
      } else {
        // User is signed out
        dispatch({
          type: Act.FIREBASE_LOGOUT_USER,
        });
        // localStorage
        localStorage.removeItem("isLogin");
      }
    });

    const idTokenNextObserver = async (user) => {
      if (user) {
        // token expiration time: 60 mins
        const token = await user.getIdToken();
        dispatch({
          type: Act.SET_USER_TOKEN,
          payload: token,
        });
      }
    };
    const onIdTokenChangeError = () => {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: intl.formatMessage({
            id: "auth.suggest.refresh.website",
            defaultMessage: "連線逾時,請重新整理網頁",
          }),
          duration: 300000, // 5 mins
        },
      });
    };
    const onIdTokenChangeComplete = () => {
      // do nothing
    };
    // observer for id token change
    onIdTokenChanged(
      auth,
      idTokenNextObserver,
      onIdTokenChangeError,
      onIdTokenChangeComplete
    );
  }, [auth]);

  return null;
};

export default AuthListener;
